import(/* webpackMode: "eager" */ "/opt/build/repo/app/kittens/page.tsx")